/** Iniciales de un nombre: primera letra de las dos primeras palabras, en mayúsculas. */
export function inicialesDe(nombre: string | null | undefined): string {
  return (nombre ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();
}
